import styled from 'styled-components';

export const ModalLogActionsWrapper = styled.div`
  .filters-container {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;

    .anticon-filter {
      color: var(--neutral_medium);
    }

    .ant-select {
      .ant-select-selector {
        border-radius: 6px;
      }
    }
  }

  .log-count {
    font-size: 13px;
    color: var(--neutral_medium);
    margin-bottom: 16px;
  }

  .timeline-container {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 8px;

    /* Scrollbar styling */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--neutral_light);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: var(--neutral_medium);
    }
  }

  .ant-timeline {
    margin-top: 10px;
  }

  .ant-timeline-item-label {
    width: 160px !important;
  }

  .timeline-label {
    font-size: 12px;
    color: var(--neutral_medium);

    .anticon {
      margin-right: 4px;
    }
  }

  .timeline-content {
    .ant-tag {
      margin-bottom: 4px;
    }

    .user-info {
      font-size: 12px;
      color: var(--neutral_light);
      margin-top: 4px;

      .anticon {
        margin-right: 4px;
      }
    }
  }

  .pagination-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;

    .pagination-info {
      font-size: 12px;
      color: var(--neutral_medium);
      min-width: 120px;
      text-align: center;
    }

    .ant-btn {
      color: var(--neutral_medium);

      &:hover:not(:disabled) {
        color: var(--primary_color);
      }

      &:disabled {
        color: var(--neutral_light);
      }
    }
  }
`;
